import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Typography,
  Card,
  Input,
  Flex,
  Carousel,
  List,
  Collapse,
  Grid,
  Select,
  Segmented,
  Form,
  Modal,
  FloatButton,
  Spin,
  Tooltip,
  Image,
  Space,
  Alert as AntdAlert,
} from "../../components/common/utils/antd-imports/AntdImports";
import {
  ThunderboltOutlined,
  SafetyOutlined,
  GlobalOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import {
  ArrowRightOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import "./Homepage.css";
import "../../main.css";
import bgimg from "../../assests/home_new_background.png";
import { useMediaQuery } from "react-responsive";

import FloatingInput from "../../components/common/float-input/FloatInput";
import buyerIcon from "../../assests/images/buyer.svg";
import adSapace from "../../assests/images/adSapace-img.svg";
import marketplaceImg from "../../assests/images/JoinMarketPlavce.png";
import newyorkimage from "../../assests/images/new-york.png";
import losAngelesImage from "../../assests/images/losAngeles.png";
import chicagoimage from "../../assests/images/chicago.png";
import texasimage from "../../assests/images/texas.png";
import dallasImage from "../../assests/images/dallas-fortWorth.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CalendarComponent from "../../components/common/calendar/CalendarComponent";
import { useDispatch, useSelector } from "react-redux";
import BillboardEnquiry from "../../components/modal/billboard-enquiry-chat/BillboardEnquiryModal";
import { getFilterProducts } from "../../store/thunks/common-thunks/commonThunk";
import { searchLocation } from "../../store/thunks/authThunk";
import { ReactComponent as EnquiryChat } from "../../assests/enquiry-chat-icon.svg";
import { ReactComponent as SearchIcon } from "../../assests/search-icon.svg";
import { ReactComponent as SelectUpIcon } from "../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../../assests/select-down-icon.svg";
import { ReactComponent as EnquiryChatMobile } from "../../assests/enquiry-chat-icon-mobile.svg";
import { ReactComponent as BuySellImage } from "../../assests/buyer-seller.svg";
import { ReactComponent as ImageAboveFooter } from "../../assests/Image-above-footer.svg";
import thumbnail from "../../assests/images/homepage.png";
import AdvertiseModal from "../../components/modal/advertise-with-amp/AdvertiseModal";
import {
  clearSelectedDMAs,
  setSelectedDMAs,
} from "../../store/thunks/common-thunks/Actions";
import dayjs from "dayjs";
import {
  setDateRange,
  setSearchText,
} from "../../store/slices/common-slice/product-filters/ProductFilter";
import { addBreadcrumb } from "../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import VideoPlayer from "../../components/common/jack-video/Video";
import Timer from "../../components/common/reusable-svg-icons/timer";
import boardhomepage from "../../../src/assests/board-home-page.png";
import mediaImage1 from "../../assests/images/media-image-1.png";
import mediaImage2 from "../../assests/images/media-image-2.png";
import mediaImage3 from "../../assests/images/media-image-3.png";
import mediaImage4 from "../../assests/images/media-image-4.png";
import heroImage from "../../assests/buyer-seller.svg";
import USAMap from "./UsaMap/UsaMap";
import { US_STATE_STATISTICS } from "./data/UsState";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const HomePage = () => {
  const location = useLocation();
  const [dmaLocations, setDmaLocations] = useState([]);
  const [Advertise, SetAdvertise] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [segment, setSegment] = useState("Advertisers");
  const { userType } = useSelector((state) => state.login);
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const navigate = useNavigate();
  const [billboardModal, setBillboardModal] = useState(false);
  const page_no = 1;
  const page_size = 8;
  const [dma, setDma] = useState(); // For the second Select (DMA)
  const [form] = Form.useForm();
  const [searchDma, setSearchDma] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      dispatch(
        setDateRange({
          from: dayjs(dates[0]).format("YYYY-MM-DD"),
          to: dayjs(dates[1]).format("YYYY-MM-DD"),
        }),
      );
    }
  };
  const videos = [
    {
      id: 1,
      src: "/AdvertisingVideo.mp4",
      // thumbnail: thumbnail,
    },
  ];

  const tickerItems = [
    "STATIC BILLBOARD",
    "DIGITAL BILLBOARD",
    "MALL MEDIA",
    "INFLIGHT BRANDING",
    "TRANSIT MEDIA",
    "METRO ADVERTISING",
    "INFLUENCER MARKETING",
  ];

  const bookSlotLink =
    "https://outlook.office.com/book/AdvertisingMarketplace@NETORG6600160.onmicrosoft.com/?ismsaljsauthenabled";
  const goToSubPage = ({ title, path }) => {
    dispatch(addBreadcrumb({ title, path }));
  };
  const PDF_BASE_URL = "/pdf";
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { searchText, selectedDateRange } = useSelector(
    (state) => state.filters,
  );
  const { locationDma, isLoading } = useSelector((state) => state.location);
  const handleProductsList = (data) => {
    const payload = {
      page_no,
      page_size,
      booked_from: selectedDateRange?.from,
      booked_to: selectedDateRange?.to,
      search_param: searchText,
      product_fromPrice: "",
      product_toPrice: "",
      product_type: [],
      size: [],

      product_dma: dma?.value ? [dma.value] : data?.value ? [data.value] : [],
    };
    if (dma?.value) {
      dispatch(
        setSelectedDMAs([
          { id: dma?.value, label: dma?.label?.replace(/-.*/, "") },
        ]),
      );
    }

    dispatch(getFilterProducts(payload));
    if (isLoggedIn) {
      goToSubPage({ title: "Shop", path: "/buyer/products" });
      navigate(`/buyer/products?search=${searchText}`);
    } else {
      goToSubPage({ title: "Shop", path: "/products" });
      navigate(`/products?search=${searchText}`);
    }
  };
  const faqData = [
    {
      key: "1",
      question: "What is an Advertising Marketplace?",
      answer: [
        "Advertising Marketplace is an AI-powered media marketplace that helps advertisers, agencies, publishers, and media owners buy and sell advertising more efficiently. By combining technology, live support, and smart recommendations, the platform streamlines discovery, pricing, and transaction workflows to make media planning and booking more transparent and strategic ",
      ],
    },
    {
      key: "2",
      question: "How does the AMP Media Buying Platform work?",
      answer: [
        "The AMP media buying platform is designed to simplify the process of discovering and purchasing. Advertisers can browse All Types of media opportunities, explore locations, and review inventory options directly on the platform.",
      ],
      additional: "Once an advertiser identifies suitable inventory, they can:",
      list: [
        "Move right to purchase it",
        "Make an offer",
        "Request payment terms",
        "Check AI Suggestions / Recommendations",
      ],
      footer:
        "AMP allows buyers to communicate with sellers via direct messaging to finalize inventory selection, campaign timelines, availability, pricing, booking confirmation, standard terms & conditions, and special requests.",
    },
    {
      key: "3",
      question: "What types of Advertising Inventory are available?",
      answer: [
        "AMP provides access to a wide range of advertising inventory across Published, non – published, programmatic and non - programmatic media channels, including All 10 channels:  ",
      ],
      listType: "ordered",
      list: [
        "OOH Billboard",
        "Events / Festival",
        "Influencer",
        "Paint",
        "Radio / Podcast",
        "Television / OTT Streaming",
        "Social",
        "Web / App",
        "Digital Network",
        "Stadium / Building / Mall",
      ],
      footer:
        "The platform helps advertisers identify advertising inventory that aligns with their target audience, campaign objectives, and geographic reach.",
    },
    {
      key: "4",
      question:
        "Can Media Owners list their Advertising Inventory on the platform?",
      answer: [
        "Yes. Media owners can showcase and manage their advertising inventory on the platform, helping them increase visibility among advertisers, agencies, and businesses of all sizes actively searching for media opportunities.",
        "AMP targets smaller local companies and businesses that are traditionally difficult to reach.",
      ],
      additional: "By listing inventory on AMP, media owners can:",
      list: [
        "Reach qualified advertising buyers",
        "Improve inventory exposure",
        "Generate direct media inquiries",
        "Simplify communication with potential advertisers",
        "Increase occupancy for available advertising spaces",
      ],
      footer:
        "AMP also assists in connecting media owners with relevant advertising opportunities through its internally and externally generated RFPs.",
    },
    {
      key: "5",
      question:
        "Which cities and locations does the Advertising Marketplace cover?",
      answer: [
        "AMP offers advertising opportunities throughout the United States.",
        "High-demand locations include Los Angeles, San Francisco Bay Area, Sacramento, Dallas, Houston, Las Vegas, Chicago, and California.",
      ],
      additional:
        "The platform focuses on positioning advertising inventory based on impressions, dates, impact, relevancy, and offer value, helping brands execute localized, regional, and multi-city advertising campaigns through strategically positioned media placements.",
    },
    {
      key: "6",
      question: "What are the benefits of using Advertising Marketplace?",
      answer: [
        "AMP simplifies the traditional media buying process by bringing advertising inventory, location discovery, and expert AI knowledge into one centralized platform.",
      ],
      additional: "Key benefits include:",
      list: [
        "Access to all types of advertising inventory across multiple cities and multiple sellers",
        "Simplified media discovery and campaign planning",
        "Direct AI access for maximization",
        "Faster campaign coordination and professional support",
        "Fully automated booking systems",
        "Efficient communication between advertisers and media owners",
      ],
      footer:
        "This hybrid approach combines current marketplace technology with human expertise to deliver a more reliable and strategic advertising experience.",
    },
  ];

  useEffect(() => {
    const targetId = location.state?.navigatedLink;

    if (!targetId) return;

    const scrollTimeout = setTimeout(() => {
      const element = document.getElementById(targetId);

      if (element) {
        const topOffset = element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: topOffset,
          behavior: "smooth",
        });
      }

      // Clear only the navigation state after attempting to scroll.
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }, 300);

    return () => {
      clearTimeout(scrollTimeout);
    };
  }, [location.state?.navigatedLink, location.pathname, navigate]);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const contentItems = [
    {
      key: "canyon-springs-plaza",
      label: "CANYON SPRINGS PLAZA",
      url: `${PDF_BASE_URL}/CanyonSprings.pdf`,
    },
    {
      key: "night-market",
      label: "626 NIGHT MARKET",
      url: `${PDF_BASE_URL}/626 Night Market.pdf`,
    },
    {
      key: "big-league-dreams",
      label: "BIG LEAGUE DREAMS",
      url: `${PDF_BASE_URL}/Big League dreams.pdf`,
    },
    {
      key: "wildrivers",
      label: "WILDRIVERS",
      url: `${PDF_BASE_URL}/Wild Rivers.pdf`,
    },
  ];

  const handleSearch = (value) => {
    setDmaLocations([]);
    setSearchDma(value);
    if (!value) {
      setDma();
      setDmaLocations([]);
      setSearchDma("");
      return;
    }
  };
  const handleChange = (value, option) => {
    if (!option) {
      setDmaLocations([]);
      setDma();
      return;
    }
    setDma(option);
  };

  const publisherSteps = [
    {
      key: 1,
      number: "01",
      title: "API",
      description: [
        "Allows for Real Time Connections",
        "Seamless Updates from your current Software",
        "Provider without any additional staffing",
      ],
    },
    {
      key: 2,
      number: "02",
      title: "Claim your Listing",
      description: [
        "Own and Control your listing",
        "Provide your Price and Availability",
        "Set your own terms and conditions",
      ],
    },
    {
      key: 3,
      number: "03",
      title: "Monitor Prospects",
      description: [
        "See Advertiser Interest",
        "Adjust Pricing and other Critical Data",
        "Yield the Best results with a click of a button",
      ],
    },
  ];
  const advertiserSteps = [
    {
      key: 1,
      number: "01",
      title: "Chatbot Advertising Marketplace",
      description: [
        "Instant help while browsing billboard options",
        "Guided support throughout campaign planning",
        "Faster, more confident decisions",
      ],
    },
    {
      key: 2,
      number: "02",
      title: "Estimated Market Value",
      description: [
        "Quick upfront pricing visibility",
        "Better budget planning with clarity",
        "Market-based advertising cost estimates",
      ],
    },
    {
      key: 3,
      number: "03",
      title: "Recommendations",
      description: [
        "Similar billboard options suggested",
        "Smarter buying decisions supported",
        "Improved campaign reach potential",
      ],
    },
  ];
  const stepsToShow =
    segment == "Advertisers" ? advertiserSteps : publisherSteps;
  const chooseUSData = [
    {
      key: "buyers",
      title: "FOR ADVERTISERS",
      header: "Build Your Ad Buys with Confidence",
      chooseImage: buyerIcon,
      items: [
        {
          label: "Open",
          description: "Anyone can list and buy",
        },
        {
          label: "Transparent",
          description: "Pricing, Availability",
        },
        {
          label: "Agnostic",
          description: 'No "thumb on the scale"',
        },
        {
          label: "Omni Channel",
          description: "All media channels",
        },
        {
          label: "Anonymous Shopping",
          description: "Look without Publisher knowing who you are",
        },
      ],
      footer: "Find The Perfect Billboard",
    },
    {
      key: "sellers",
      title: "FOR PUBLISHERS",
      header: "Maximize Your Resources",
      chooseImage: adSapace,
      items: [
        {
          label: "Direct",
          description: "No Middle Men",
        },
        {
          label: "Secure",
          description: "State of the Art Security",
        },
        {
          label: "Control",
          description: "You decide what to list, the price, and the terms",
        },
        {
          label: "Billing",
          description: "You invoice the Advertiser",
        },
        {
          label: "Terms",
          description: "State your company policy",
        },
        {
          label: "Restrictions",
          description: "Let Advertisers know what you can and cannot accept",
        },
        {
          label: "Communicate with Advertisers",
          description: "Advertisers ask you questions before they buy",
        },
      ],
      footer: "List Your Ad Now",
    },
  ];

  const benefitSteps = [
    {
      benefitTitle: "Access to Buying and Selling Beyond only Shopping",
      description: "",
    },
    {
      benefitTitle: "Today's Technology",
      description: "AI Features tailored for the AD Industry",
    },
    {
      benefitTitle: "Current Data",
      description: "Up To Data Pricing and Availability",
    },
    {
      benefitTitle: "Human Touch",
      description: "SME or Subject Matter Experts available to help if needed",
    },
    {
      benefitTitle: "Advanced Tools",
      description: "Access Deep Dive Contextual Data and Insights",
    },
  ];
  // COMMENTED FOR NEXT RELEASE
  // const services = [
  //   {
  //     title: "Hourly Assist",
  //     description:"Tailored support to handle your advertising needs on demand.",
  //     icon: <Timer/>,
  //   },
  //   {
  //     title: "Bulk Upload",
  //     description:"Effortlessly upload large volumes oflistings in a single streamlined process.",
  //     icon:"",
  //   },
  //   {
  //     title:"Geo Monitoring",
  //     description:"Real-time location insights that help you track ad visibility across cities.",
  //     icon:"",
  //   },
  //   {
  //     title:"Sponsored Ads (Paid Search)",
  //     description: "Boost your reach with premium placements that attract high-intent buyers.",
  //     icon:"",
  //   },
  //   {
  //     title:"Standard Advertising",
  //     description: "Run impactful display campaigns that promote your brand to the right audience.",
  //     icon:"",
  //   }
  // ]
  const navigateToSignUp = (event) => {
    event.preventDefault();

    const selectedUser = event.currentTarget.getAttribute("data-user");
    if (isLoggedIn) {
      if (userType === "basic") {
        goToSubPage({ title: "Shop", path: "/buyer/products" });
        navigate("/buyer/products", { state: { selectedUser } });
      } else if (userType === "owner") {
        goToSubPage({ title: "Dashboard", path: "/seller/dashboard" });
        navigate("/seller/dashboard", { state: { selectedUser } });
      }
    } else {
      navigate("/signup", { state: { selectedUser } });
    }
  };
  const navigateToDashBoard = () => {
    if (isLoggedIn) {
      if (userType === "basic") {
        goToSubPage({ title: "Dashboard", path: "/buyer/dashboard" });
        navigate("/buyer/dashboard", { state: { selectedUser: userType } });
      } else if (userType === "owner") {
        goToSubPage({ title: "Dashboard", path: "/seller/dashboard" });
        navigate("/seller/dashboard", { state: { selectedUser: userType } });
      }
    } else {
      navigate("/signup", { state: { selectedUser: userType } });
    }
  };
  const navigateToLeadGeneration = () => {
    if (isLoggedIn) {
      if (userType === "basic") {
        goToSubPage({
          title: "Lead Generation",
          path: "/buyer/get-in-touch",
        });
        navigate("/buyer/get-in-touch", {
          state: { selectedUser: userType },
        });
      }
    } else {
      goToSubPage({ title: "Lead Generation", path: "/buyer/get-in-touch" });
      navigate("/get-in-touch");
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchDma) {
        dispatch(searchLocation(searchDma));
      }
    }, 500);

    return () => {
      clearTimeout(delayDebounce);
    };
  }, [dispatch, searchDma]);

  useEffect(() => {
    if (locationDma) {
      const v =
        locationDma &&
        locationDma?.map((location, index) => ({
          label: `${location.city_name} - ${location.name}`, // Assuming the API returns 'name' for the label
          value: location.id, // Assuming the API returns 'id' for the value
        }));
      setDmaLocations(v);
    }
    dispatch(clearSelectedDMAs());
  }, [dispatch, locationDma]);

  useEffect(() => {
    dispatch(setSearchText(""));
  }, [dispatch]);

  const handleDynamicCityClick = (data) => {
    const dmaId = data?.value;
    if (isLoggedIn) {
      //handleProductsList(data);
      goToSubPage({ title: "Shop", path: "/buyer/products" });
      navigate(`/buyer/products?dmas=${dmaId}`);
    } else {
      goToSubPage({ title: "Shop", path: "/products" });
      navigate(`/products?dmas=${dmaId}`);
    }
  };
  const VideoPlayer = ({
    src,
    thumbnail,
    autoPlay = true,
    muted = true,
    loop = true,
  }) => {
    return (
      <div className="video-player-wrapper">
        <video
          src={src}
          poster={thumbnail}
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          playsInline
          controls={false}
          preload="auto"
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
        />
      </div>
    );
  };

  const [selectedMedia, setSelectedMedia] = useState(0);
  const [activeUserType, setActiveUserType] = useState("seller");

  const mediaItems = [
    {
      id: 1,
      image: mediaImage1,
      category: "Static Billboard",
      title: "Static Billboard Advertising",
    },
    {
      id: 2,
      image: mediaImage2,
      category: "Digital Billboard",
      title: "Digital Billboard Advertising",
    },
    {
      id: 3,
      image: mediaImage3,
      category: "Mall Media",
      title: "Mall Media Advertising",
    },
    {
      id: 4,
      image: mediaImage4,
      category: "Inflight Branding",
      title: "Inflight Branding",
    },
  ];

  const userTypeContent = {
    seller: {
      title: "I'm a Seller",
      description:
        "Browse thousands of verified ad spaces across billboards, radio, digital, TV, and more. Build campaigns and manage everything from one place.",
      points: [
        "Search 12,400+ ad spaces",
        "Build multi-channel campaigns",
        "Track performance in real-time",
      ],
      actionButton: "Start as Seller",
    },
    buyer: {
      title: "I'm a Buyer",
      description:
        "Discover premium advertising opportunities across billboards, digital, radio, TV, and more. Find the right advertising spaces and reach your audience.",
      points: [
        "Discover verified advertising spaces",
        "Compare multiple media opportunities",
        "Launch campaigns with ease",
      ],
      actionButton: "Start as Buyer",
    },
  };

  const activeContent = userTypeContent[activeUserType];

  const testimonials = [
    {
      id: 1,
      quote:
        "This platform revolutionized how we buy billboard space. The search functionality and real-time availability made our campaign launch seamless.",
      name: "Sarah Johnson",
      role: "Marketing Director, TechCorp Inc.",
    },
    {
      id: 2,
      quote:
        "As a billboard owner, this marketplace connected us with premium brands we never would have reached otherwise. Revenue is up 40%.",
      name: "Michael Chen",
      role: "Owner, Metro Outdoor Advertising",
    },
    {
      id: 3,
      quote:
        "The analytics dashboard gives us unprecedented insight into campaign performance. It's changed how we approach outdoor advertising.",
      name: "Emily Rodriguez",
      role: "Brand Manager, Lifestyle Brands Co.",
    },
  ];

  const [openFaqIndex, setOpenFaqIndex] = useState(0); // first question open by default

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const selectedStatistics = selectedState
    ? US_STATE_STATISTICS[selectedState.id]
    : null;

  return (
    <>
      <div className="layout">
        <div className="home-cont">
          <Row
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="video-hero-container">
              {/* Video */}
              {videos?.map((video) => (
                <VideoPlayer
                  key={video?.id}
                  src={video?.src}
                  thumbnail={video?.thumbnail}
                  autoPlay
                  muted
                  loop
                />
              ))}

              {/* Content on top of video */}
              <div className="video-hero-content">
                <div className="video-hero-badge">
                  <Text className="video-hero-dot">•</Text>{" "}
                  <Text className="video-hero-text">
                    The open advertising marketplace
                  </Text>
                </div>
                <Text className="home_main_heading">
                  BUY AND SELL ADVERTISING
                  <br />
                  IN ONE SMART <span>MARKETPLACE</span>
                </Text>

                <p className="home_main_paragraph">
                  Discover advertising opportunities across billboards, radio,
                  digital media, and more. Connect with trusted sellers, build
                  campaigns, and manage everything in one place.
                </p>

                <p className="video-hero-select-text">
                  Select one to get started.
                </p>

                <div className="video-hero-buttons">
                  <button
                    type="button"
                    className="video-hero-btn-primary"
                    onClick={() => {
                      navigate("/signup", {
                        state: {
                          selectedUser: "buyer",
                        },
                      });
                    }}
                  >
                    I'm a Buyer
                  </button>
                  <button
                    type="button"
                    className="video-hero-btn-primary"
                    onClick={() => {
                      navigate("/signup", {
                        state: {
                          selectedUser: "seller",
                        },
                      });
                    }}
                  >
                    I'm a Seller
                  </button>
                  {/* <button type="button" className="video-hero-btn-outline">
                    Advertise on AMP (Partner)
                  </button> */}
                </div>
              </div>
            </div>
          </Row>
        </div>
        <AntdAlert
          className="Add-banner-alert"
          message={
            <div className="banner-content">
              <span className="banner-content-span">
                12,400+ Ad Spaces Listed
              </span>
              <span className="banner-content-span">
                $48M+ Gross ad assets available
              </span>
            </div>
          }
        />
        <div className="advertising-content-main">
          <div className="advertising-content-new">
            <Text>
              WHAT IS
              <br />
              <span>ADVERTISING MARKETPLACE?</span>
            </Text>
            <Text>
              AMP is a unified digital platform that connects businesses looking
              to advertise with media owners who have advertising spaces to sell
              across all channels, in one place.
            </Text>
            <br></br>
            <Text>
              Whether you're a brand searching for billboard placements, a radio
              station selling airtime, or a business looking to promote your
              brand directly on the AMP platform to reach our media-focused
              audience AMP streamlines discovery, negotiation, contracting, and
              payment into a single seamless workflow.
            </Text>

            <div className="marketplace-features">
              <div className="feature-card">
                <div className="feature-icon">
                  <ThunderboltOutlined style={{ color: "#d50032" }} />
                </div>
                <Text>Fast Discovery</Text>
                <span>Find the right spaces in minutes</span>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <SafetyOutlined style={{ color: "#d50032" }} />
                </div>
                <Text>Verified Listings</Text>
                <span>Trusted buyers and sellers</span>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <GlobalOutlined />
                </div>
                <Text>All Channels</Text>
                <span>Billboard, radio, digital & more</span>
              </div>
            </div>
          </div>
          <img
            className="advertising-main-img"
            src={boardhomepage}
            alt="Advertising Marketplace"
          />
        </div>

        {/* ===== NEW SECTION: MAP + WE GET YOU EVERYWHERE ===== */}

        <div className="amp-reach-section">
          {/* Left: USA Map + Stats */}
          <div className="amp-reach-left">
            <div className="locations-map-content">
              <USAMap onStateSelect={setSelectedState} />
              {/* <div className="maps-card-section">
                <GoogleMapsComponent
                  className="google-map-container"
                  isProductModal={true}
                  zoomControlState={false}
                  // productLocations={productLocations}
                />{" "}
              </div> */}
              <div className="usa-statistics">
                <Card variant="borderless" className="usa-stat-card">
                  <div className="stat-card-inner">
                    <div>
                      <span className="usa-stat-number">
                        {selectedStatistics?.billboardLocations || "50K+"}
                      </span>
                      <span className="usa-stat-label">
                        Billboard Locations
                      </span>
                    </div>
                    <AppstoreOutlined className="stat-card-icon" />
                  </div>
                </Card>

                <Card variant="borderless" className="usa-stat-card">
                  <div className="stat-card-inner">
                    <div>
                      <span className="usa-stat-number">
                        {selectedStatistics?.dailyImpressions || "10M+"}
                      </span>
                      <span className="usa-stat-label">Daily Impressions</span>
                    </div>
                    <LineChartOutlined className="stat-card-icon" />
                  </div>
                </Card>
              </div>
            </div>
          </div>

          {/* Right: We Get You Everywhere */}
          <div className="amp-reach-right">
            <div className="locations-reach-content">
              <Text className="aligned-main-title">
                WE GET YOU
                <br />
                <span>EVERYWHERE</span>
              </Text>

              <p className="aligned-description-text reach-subtext">
                From bustling city centers to suburban highways, our network
                spans the globe's most high-traffic locations.
              </p>

              <div className="reach-items-list">
                <div className="reach-item">
                  <span className="reach-number">1</span>
                  <div className="reach-item-info">
                    <span className="reach-item-title">
                      Premium Urban Locations
                    </span>
                    <span className="reach-item-description">
                      High-visibility placements in major metropolitan areas
                    </span>
                  </div>
                </div>

                <div className="reach-item">
                  <span className="reach-number">2</span>
                  <div className="reach-item-info">
                    <span className="reach-item-title">
                      Strategic Highway Coverage
                    </span>
                    <span className="reach-item-description">
                      Capture commuter traffic on major transportation routes
                    </span>
                  </div>
                </div>

                <div className="reach-item">
                  <span className="reach-number">3</span>
                  <div className="reach-item-info">
                    <span className="reach-item-title">
                      Neighborhood Presence
                    </span>
                    <span className="reach-item-description">
                      Local market penetration for targeted campaigns
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ===== END NEW SECTION ===== */}

        {/* FORMAT TICKER (INFINITE SCROLLING MARQUEE) */}
        <div className="format-ticker-section">
          <div className="format-ticker-track">
            {/* Duplicated for seamless infinite loop */}
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <div key={index} className="format-ticker-item">
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= MEDIA SHOWCASE ================= */}
        <div className="media-showcase-section">
          <div className="media-showcase-container">
            <div className="media-showcase-content">
              {/* LEFT: large image */}
              <div className="media-showcase-left">
                <div className="media-showcase-header">
                  <Text>
                    SEE <span>AMP IN ACTION</span>
                  </Text>
                  <Text>Short videos to help you get started quickly.</Text>
                </div>
                <div className="media-main-image-container">
                  <Image
                    preview={false}
                    src={mediaItems[selectedMedia].image}
                    alt={mediaItems[selectedMedia].title}
                    className="media-main-image"
                  />

                  <div className="media-duration">2:34</div>

                  <div className="media-main-overlay">
                    <Text>{mediaItems[selectedMedia].title}</Text>
                    <Text>
                      Explore this advertising format and learn how AMP works.
                    </Text>
                  </div>
                </div>

                <div className="media-bottom-controls">
                  <div className="media-dots">
                    {mediaItems.map((_, index) => (
                      <span
                        key={index}
                        className={`media-dot ${
                          selectedMedia === index ? "active" : ""
                        }`}
                        onClick={() => setSelectedMedia(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* RIGHT: thumbnail list */}
              <div className="media-showcase-right">
                <div className="media-list-title">All Videos</div>

                <div className="media-image-list">
                  {mediaItems.map((item, index) => (
                    <div
                      key={item.id}
                      className={`media-image-card ${
                        selectedMedia === index ? "active" : ""
                      }`}
                      onClick={() => setSelectedMedia(index)}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="media-thumbnail"
                      />
                      <div className="media-card-content">
                        <span>{item.category}</span>
                        <Text>{item.title}</Text>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= LET'S GET STARTED ================= */}
        <div className="get-started-section">
          <div className="get-started-container">
            <div className="get-started-header">
              <div className="get-started-heading">
                <Text>
                  LETS GET <span>STARTED</span>
                </Text>
                <Text>
                  Tell us how you plan to use AMP and we’ll guide you to the
                  right place
                </Text>
              </div>

              <div className="user-type-toggle">
                <button
                  className={
                    activeUserType === "buyer"
                      ? "user-type-button active"
                      : "user-type-button"
                  }
                  onClick={() => setActiveUserType("buyer")}
                >
                  <span className="user-type-icon">▣</span>
                  <span>I'm a Buyer</span>
                </button>

                <button
                  className={
                    activeUserType === "seller"
                      ? "user-type-button active"
                      : "user-type-button"
                  }
                  onClick={() => setActiveUserType("seller")}
                >
                  <span className="user-type-icon">▣</span>
                  <span>I'm a Seller</span>
                </button>
              </div>
            </div>
            <div className="get-started-card">
              <div className="get-started-image">
                <img src={heroImage} alt="Advertising Marketplace" />
              </div>

              <div className="get-started-content">
                <div className="get-started-content-icon">▣</div>

                <Text>{activeContent.title}</Text>

                <p className="get-started-description">
                  {activeContent.description}
                </p>

                <div className="get-started-points">
                  {activeContent.points.map((point, index) => (
                    <div className="get-started-point" key={index}>
                      <span className="get-started-check">✓</span>
                      <span>{point}</span>
                    </div>
                  ))}
                </div>

                <Button
                  type="primary"
                  className="rtgs-btn"
                  onClick={() => {
                    navigate("/signup", {
                      state: {
                        selectedUser: activeUserType,
                      },
                    });
                  }}
                >
                  <span className="get-started-arrow ">
                    {activeContent.actionButton}
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* ================= WHAT OUR CLIENTS SAY ================= */}
        <div className="testimonials-section">
          <div className="testimonials-container">
            <h2 className="testimonials-title">
              WHAT OUR
              <br />
              <span>CLIENTS SAY</span>
            </h2>

            <div className="testimonials-grid">
              {testimonials?.map((item) => (
                <div key={item.id} className="testimonial-card">
                  <p className="testimonial-quote">"{item.quote}"</p>

                  <div className="testimonial-author">
                    <span className="testimonial-name">{item.name}</span>
                    <span className="testimonial-role">{item.role}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* ================= FREQUENTLY ASKED QUESTIONS ================= */}
        <div id="frequently-asked-questions" className="home-faq-section">
          <div className="home-faq-container">
            <h2 className="home-faq-title">
              FREQUENTLY
              <br />
              <span>ASKED QUESTIONS</span>
            </h2>

            <div className="home-faq-list">
              {faqData.map((item, index) => {
                const isOpen = openFaqIndex === index;

                return (
                  <div
                    key={item.key}
                    className={`home-faq-item ${isOpen ? "open" : ""}`}
                  >
                    <button
                      type="button"
                      className="home-faq-question"
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.question}</span>
                      <span className="home-faq-icon" />
                    </button>

                    <div className="home-faq-answer-wrap">
                      <div className="home-faq-answer-inner">
                        <div>
                          {/* Answer paragraphs */}
                          {item.answer?.map((paragraph, answerIndex) => (
                            <Text key={answerIndex} className="faq-answer-test">
                              {paragraph}
                              <br />
                            </Text>
                          ))}

                          {/* Additional text */}
                          {item.additional && (
                            <div style={{ marginTop: "10px" }}>
                              <Text className="faq-answer-test">
                                {item.additional}
                              </Text>
                            </div>
                          )}

                          {/* List */}
                          {item.list?.length > 0 &&
                            (item.listType === "ordered" ? (
                              // Numbered list
                              <ol className="faq-answer-test">
                                {item.list.map((listItem, listIndex) => (
                                  <li
                                    key={listIndex}
                                    className="faq-answer-test"
                                  >
                                    <Text className="faq-answer-test">
                                      {listItem}
                                    </Text>
                                  </li>
                                ))}
                              </ol>
                            ) : (
                              // Bullet list
                              <ul className="faq-answer-test">
                                {item.list.map((listItem, listIndex) => (
                                  <li
                                    key={listIndex}
                                    className="faq-answer-test"
                                  >
                                    <Text className="faq-answer-test">
                                      {listItem}
                                    </Text>
                                  </li>
                                ))}
                              </ul>
                            ))}

                          {/* Footer */}
                          {item.footer && (
                            <Text className="faq-answer-test">
                              {item.footer}
                            </Text>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="home-faq-more">
              {/* <button type="button" className="home-faq-more-button">
                See More
              </button> */}
            </div>
          </div>
        </div>

        <div className="rtgs">
          <div className="rtgs-inner">
            <h2 className="rtgs-text">READY TO GET STARTED?</h2>
            <p className="rtgs-para">
              Join thousands of buyers and sellers already using our platform to
              transform their outdoor advertising business.
            </p>
          </div>
          <div className="rtgs-btn-comp">
            <button
              type="button"
              className="rtgs-btn"
              onClick={() => {
                navigate("/signup", {
                  state: {
                    selectedUser: "buyer",
                  },
                });
              }}
            >
              Start As Buyer
            </button>
            <button
              type="button"
              className="rtgs-btn"
              onClick={() => {
                navigate("/signup", {
                  state: {
                    selectedUser: "seller",
                  },
                });
              }}
            >
              Start As Seller
            </button>
            {/* <button type="button" className="rtgs-btn">
              Advertise On Amp
            </button> */}
          </div>
          <div className="rtgs-features">
            <div className="rtgs-feature-item">
              <CheckCircleOutlined className="rtgs-check-icon" />
              <span>Verified sellers and buyers</span>
            </div>
            <div className="rtgs-feature-item">
              <CheckCircleOutlined className="rtgs-check-icon" />
              <span>Secure DocuSign agreements</span>
            </div>
            <div className="rtgs-feature-item">
              <CheckCircleOutlined className="rtgs-check-icon" />
              <span>Real-time campaign tracking</span>
            </div>
          </div>
        </div>

        {/* Search Billboard Advertising Across the Country Section */}
        {/* <div className="country-search-section">
          <div className="country-search-container">
            <Text className="country-search-title">
              Search Billboard Advertising Across the Country
            </Text>
            <p className="country-search-subtitle">
              Find billboard locations by city, format, and visibility to launch
              your next campaign faster.
            </p>

            <div className="country-search-grid">
              <div className="country-search-column">
                <Text
                  className="country-search-link"
                  onClick={() => {
                    handleDynamicCityClick({
                      value: "5ba2236c199c6",
                      label: "New York",
                    });
                  }}
                >
                  Billboard Advertising in New York City
                </Text>
                <Text
                  className="country-search-link"
                  onClick={() => {
                    handleDynamicCityClick({
                      value: "5c19ae6f2e2d5",
                      label: "Los angeles",
                    });
                  }}
                >
                  Billboard Advertising in Los Angeles
                </Text>
                <Text
                  className="country-search-link"
                  onClick={() => {
                    handleDynamicCityClick({
                      value: "5ebe08121f160",
                      label: "Chicago",
                    });
                  }}
                >
                  Billboard Advertising in Chicago
                </Text>
                <span className="country-search-link">
                  Billboard Advertising in Houston
                </span>
                <span className="country-search-link">
                  Billboard Advertising in Miami
                </span>
                <span className="country-search-link">
                  Billboard Advertising in San Francisco
                </span>
              </div>

              <div className="country-search-column">
                <span className="country-search-link">
                  Digital Billboard Advertising
                </span>
                <span className="country-search-link">
                  Static Billboard Advertising
                </span>
                <span className="country-search-link">
                  Highway Billboard Advertising
                </span>
                <span className="country-search-link">
                  LED Billboard Advertising
                </span>
                <span className="country-search-link">
                  Outdoor Billboard Advertising
                </span>
              </div>

              <div className="country-search-column">
                <span className="country-search-link">
                  Billboard Near Highway
                </span>
                <span className="country-search-link">
                  Billboard in Downtown Area
                </span>
                <span className="country-search-link">
                  Billboard Near Airports
                </span>
                <span className="country-search-link">
                  Billboard Near Shopping Malls
                </span>
                <span className="country-search-link">
                  Billboard Near High-Traffic Areas
                </span>
              </div>

              <div className="country-search-column">
                <span className="country-search-link">
                  Affordable Billboard Advertising USA
                </span>
                <span className="country-search-link">
                  Premium Billboard Locations USA
                </span>
                <span className="country-search-link">
                  High-Visibility Billboard Ads
                </span>
                <span className="country-search-link">
                  Cost-Effective Outdoor Advertising
                </span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="image-above-footer">
          <ImageAboveFooter
            className="footer-image"
            // preserveAspectRatio="xMidYMid slice"
          />
        </div>
      </div>
      <Modal
        open={Advertise}
        onCancel={() => {
          setSelectedImage(null);
          SetAdvertise(false);
          form.resetFields();
        }}
        footer={null}
        width="58.438rem"
        height="85%"
        className="custom-advertise-modal"
      >
        <AdvertiseModal
          form={form}
          Advertise={Advertise}
          SetAdvertise={SetAdvertise}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
        />
      </Modal>
    </>
  );
};
export default HomePage;
